
export default {
  loading: '' // TODO: generate URL for assets/loader.gif
}